import {Injectable} from '@angular/core';
import {
  MydocmaPromptButtonTypeEnum,
  MydocmaPromptResult,
  PromptDialogService
} from '@mydocma/component-library/src/lib/prompt-dialog';
import {TranslateService} from '@ngx-translate/core';
import {PlatformModeStateService} from './platform-mode-state.service';
import {MmLayoutStateService} from '../../mm-filter/layout/layout-state.service';
import {LocalLayoutService} from './local-layout.service';
import {ConnectivityService} from "@mydocma/core";
import {switchMap} from "rxjs";
import {map, withLatestFrom} from "rxjs/operators";
import { PlatformModeService } from './platform-mode.service';
import { MmFilterService } from '../../mm-filter/mm-filter.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineLocalModeMessageService {

  private isOfflineDialogOpen = false;
  private lastShownOfflineDialog: number | null = null;
  private cooldownOfflineDialog = 30000;

  constructor(private readonly dialogService: PromptDialogService,
              private readonly translateService: TranslateService,
              private platformModeStateService: PlatformModeStateService,
              public readonly layoutStateService: MmLayoutStateService,
              public readonly localLayoutService: LocalLayoutService,
              protected readonly connectivityService: ConnectivityService,
              private readonly platformModeService: PlatformModeService,
              private readonly mmFilterService: MmFilterService) {

    this.platformModeStateService.showNoInternetMessage$.pipe(
        withLatestFrom(this.connectivityService.isOffline)
      )
      .subscribe(([e, isOffline]) => {
        if (e.show && isOffline) {
          this.showNoInternetMessage(e.cooldown ?? false, e.isLocalMode);
        }
      });
  }

  async showNoInternetMessage(showWithCooldown: boolean, isLocalMode: boolean){
    const now = Date.now();
    if (showWithCooldown && (this.lastShownOfflineDialog && now - this.lastShownOfflineDialog < this.cooldownOfflineDialog) || this.isOfflineDialogOpen) {
      return;
    }
    let dialogResult: MydocmaPromptResult;
    this.isOfflineDialogOpen = true;
    if (isLocalMode){
      dialogResult = await this.dialogService.showOfflineNotificationDialog();
    }
    else{
      dialogResult = await this.dialogService.showPromptDialog(this.createPromptDialogConfig('offlineNotLocalMode'));
    }

    this.isOfflineDialogOpen = false;
    this.lastShownOfflineDialog = Date.now();

    if (dialogResult?.value){
      const localLayout = this.localLayoutService.getLocalLayout();

      this.mmFilterService.clearAllFilters();
      this.layoutStateService.setSearchFilter([]);
      this.layoutStateService.setLayout(localLayout);
      this.platformModeService.setLocalMode(true);
    }
  }

  async showActionNotAvailableInLocalModeDialog(){
    if (this.isOfflineDialogOpen){return; }
    let dialogResult: MydocmaPromptResult;
    this.isOfflineDialogOpen = true;
    dialogResult = await this.dialogService.showPromptDialog(this.createPromptDialogConfig('actionNotAvailableInLocalMode'));
    this.isOfflineDialogOpen = false;
  }

  private createPromptDialogConfig(type: 'offlineNotLocalMode' | 'actionNotAvailableInLocalMode'){
    switch (type){
      case 'offlineNotLocalMode':
        return {
          title: this.translateService.instant('MM.dialog.offlineDialog.title'),
          content: this.translateService.instant('MM.dialog.offlineDialog.content'),
          buttons: [
            {
              type: MydocmaPromptButtonTypeEnum.default,
              text: this.translateService.instant('MM.general.button.later'),
              value: false
            },
            {
              type: MydocmaPromptButtonTypeEnum.primary,
              text: this.translateService.instant('MM.general.button.ok'),
              value: true
            }
          ]
        };

      case 'actionNotAvailableInLocalMode':
        return {
          title: this.translateService.instant('MM.dialog.actionNotAvailableInLocalModeDialog.title'),
          content: this.translateService.instant('MM.dialog.actionNotAvailableInLocalModeDialog.content'),
          buttons: [
            {
              type: MydocmaPromptButtonTypeEnum.primary,
              text: this.translateService.instant('MM.general.button.ok'),
              value: true
            },
          ]
        };
    }
  }
}
